import { z } from "zod";

import http from "@/services/http";

const enrollgenAIParams = z.object({
  genai_opt_in: z.boolean().nullish(),
  genai_opt_out: z.boolean().nullish(),
  genai_survey: z.boolean().nullish(),
  genai_interview: z.boolean().nullish(),
  genai_agreement: z.boolean().nullish(),
  ciscou_agreement: z.boolean().nullish(),
});

export type ContentParams = z.infer<typeof enrollgenAIParams>;

export async function enrollGenAIUser(content: ContentParams) {
  if (!window.env.PROFILE_API_LOCATION) {
    return;
  }
  return await http().post(
    `${window.env.PROFILE_API_LOCATION}/enrollGenAI`,
    content
  );
}
